var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 238.4 380.2",
    style: {
      enableBackground: "new 0 0 238.4 380.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B38FC6;}\n\t.st1{fill:#5C3B6B;}\n\t.st2{fill:#4D2C5C;}\n\t.st3{fill:#88609B;}\n\t.st4{fill:#654376;}\n\t.st5{fill:#D59D7D;}\n\t.st6{fill:#BEB8E2;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#331E3F;}\n\t.st9{fill:#B57A53;}\n\t.st10{fill:#9D6341;}\n\t.st11{fill:#482A20;}\n\t.st12{fill:#AE8062;}\n\t.st13{fill:#613B21;}\n\t.st14{fill:#3F4993;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5454",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22338",
    className: "st0",
    d: "M211.4,375.3l14.6-2.5c2.5-0.4,4.1-2.8,3.7-5.2l-7-40.2c-0.4-2.5-2.8-4.1-5.2-3.7 l-14.6,2.5c-2.5,0.4-4.1,2.8-3.7,5.2c0,0,0,0,0,0l7,40.2C206.5,374.1,208.9,375.8,211.4,375.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22340",
    className: "st0",
    d: "M134.4,367.9l11.1-1c3.5-0.3,6.1-3.4,5.8-6.9l-3.4-37c-0.3-3.5-3.4-6.1-6.9-5.8l-11.1,1 c-3.5,0.3-6.1,3.4-5.8,6.9l3.4,37C127.8,365.7,130.9,368.2,134.4,367.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22345",
    className: "st1",
    d: "M197.1,177l11.4,84.1l23,94.3h-31.3l-28.9-89.9L146.8,177L197.1,177z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22346",
    className: "st1",
    d: "M155,177.3l-2.6,83.9l4.4,93.8l-29.3,1.6l-11.1-90.1l-6.9-88.3L155,177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22347",
    className: "st1",
    d: "M198,200.2h-86.8l-3.4-45.1h88.1L198,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22348",
    className: "st2",
    d: "M110.3,187.8c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3c0,0,0,0,0,0 c7.9,0,14.3-6.4,14.3-14.3c0-0.1,0.1-0.3,0.3-0.3c0.1,0,0.2,0.1,0.3,0.3C125.2,181.1,118.5,187.8,110.3,187.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22349",
    className: "st2",
    d: "M197.6,187.8c-8.2,0-14.8-6.7-14.8-14.8c0-0.1,0.1-0.3,0.3-0.3c0.1,0,0.2,0.1,0.3,0.3 c0,7.9,6.4,14.3,14.3,14.3c0.1,0,0.3,0.1,0.3,0.3C197.9,187.7,197.7,187.8,197.6,187.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22350",
    className: "st2",
    d: "M172.9,169.7H117c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.3-0.3h55.9 c0.1,0,0.3,0.1,0.3,0.3C173.2,169.5,173,169.7,172.9,169.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22351",
    className: "st2",
    d: "M192.9,169.7h-15.2c-0.1,0-0.3-0.1-0.3-0.3c0-0.1,0.1-0.3,0.3-0.3h15.2 c0.1,0,0.3,0.1,0.3,0.3S193,169.7,192.9,169.7C192.9,169.7,192.9,169.7,192.9,169.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22352",
    className: "st2",
    d: "M152.1,174.3h-10.6c-0.7,0-1.3-0.6-1.3-1.3v-7.2c0-0.7,0.6-1.3,1.3-1.3h10.6 c0.7,0,1.3,0.6,1.3,1.3v7.2C153.3,173.7,152.8,174.3,152.1,174.3 M141.5,165.1c-0.4,0-0.7,0.3-0.7,0.7v7.2c0,0.4,0.3,0.7,0.7,0.7 h10.6c0.4,0,0.7-0.3,0.7-0.7v-7.2c0-0.4-0.3-0.7-0.7-0.7H141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22353",
    className: "st2",
    d: "M177.5,173.5c-0.1,0-0.3-0.1-0.3-0.3v0v-7.7c0-0.1,0.1-0.3,0.3-0.3c0.1,0,0.3,0.1,0.3,0.3 c0,0,0,0,0,0v7.7C177.8,173.4,177.7,173.5,177.5,173.5L177.5,173.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22354",
    className: "st2",
    d: "M173,173.5c-0.1,0-0.3-0.1-0.3-0.3v0v-7.7c0-0.1,0.1-0.3,0.3-0.3c0.1,0,0.3,0.1,0.3,0.3 c0,0,0,0,0,0v7.7C173.3,173.4,173.2,173.5,173,173.5L173,173.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22355",
    className: "st2",
    d: "M154.4,346.3h-31.5c-0.8,0-1.4,0.6-1.4,1.4c0,0.1,0,0.1,0,0.2l0.9,6.5 c0.1,0.7,0.7,1.2,1.4,1.2h30.6c0.8,0,1.4-0.6,1.4-1.4c0,0,0,0,0,0v-6.5C155.8,346.9,155.2,346.2,154.4,346.3 C154.4,346.3,154.4,346.3,154.4,346.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22356",
    className: "st2",
    d: "M230.1,346.3h-32.9c-1,0-1.8,0.8-1.8,1.8c0,0.2,0,0.4,0.1,0.6l1.9,5.6 c0.2,0.7,0.9,1.3,1.7,1.3h32.5c1,0,1.8-0.8,1.8-1.8c0-0.2,0-0.3-0.1-0.5l-1.5-5.6C231.7,346.8,230.9,346.3,230.1,346.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22357",
    className: "st3",
    d: "M235.8,375.5c0-8.3-8-15.1-17.8-15.1s-17.8,6.8-17.8,15.1H235.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22358",
    className: "st4",
    d: "M198.8,380.2h38.3c0.7,0,1.3-0.6,1.3-1.3v-2.2c0-0.7-0.6-1.3-1.3-1.3h-38.3 c-0.7,0-1.3,0.6-1.3,1.3v2.2C197.5,379.6,198.1,380.2,198.8,380.2C198.8,380.2,198.8,380.2,198.8,380.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22359",
    className: "st2",
    d: "M151.8,197.9c-0.1,0-0.2-0.1-0.3-0.2l-3.9-21.5c0-0.1,0.1-0.3,0.2-0.3s0.3,0.1,0.3,0.2 c0,0,0,0,0,0l3.9,21.5C152.1,197.7,152,197.8,151.8,197.9C151.9,197.9,151.9,197.9,151.8,197.9 C151.9,197.9,151.9,197.9,151.8,197.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22360",
    className: "st2",
    d: "M148.5,351.2c-0.1,0-0.3-0.1-0.3-0.3l-5.3-90.4l3.6-60.3c0-0.1,0.1-0.3,0.3-0.3 c0,0,0,0,0,0c0.1,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0l-3.6,60.3l5.3,90.3C148.8,351,148.7,351.2,148.5,351.2 C148.5,351.2,148.5,351.2,148.5,351.2L148.5,351.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22361",
    className: "st5",
    d: "M70.3,128.5L70.3,128.5c4.5,4.6,11.9,4.8,16.5,0.3L139,78.5c5.4-5.2,5.5-13.7,0.4-19 s-13.7-5.5-19-0.4c-0.2,0.2-0.3,0.3-0.5,0.5L70.6,112C65.9,116.5,65.8,123.9,70.3,128.5C70.3,128.5,70.3,128.5,70.3,128.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22362",
    className: "st5",
    d: "M14.1,76.6L14.1,76.6C11.8,80,12.9,85,16.8,88l53.8,41.3c6.3,4.4,14.4,3.6,18.1-1.7 c3.7-5.3,1.5-13.2-4.8-17.5l-58.4-35C21.4,72.6,16.4,73.3,14.1,76.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22363",
    className: "st5",
    d: "M30.3,83.1c0.1-1.8,0-3.5-0.2-5.3c-0.2-1.7-0.5-3.4-0.9-5.1c-0.4-1.7-1-3.3-1.8-4.9 c-0.8-1.5-1.8-3-3-4.2c-0.4-0.3-0.9-0.3-1.3,0c-0.3,0.3-0.3,0.7-0.1,1.1l0,0.1c1.3,2.6,1.8,5.5,1.6,8.4c-0.1,1.5-0.3,2.9-0.6,4.3 c-0.3,1.4-0.6,2.7-1.1,4.1c-0.8,2,0.2,4.2,2.2,4.9s4.2-0.2,4.9-2.2c0.1-0.4,0.2-0.8,0.2-1.2L30.3,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22364",
    className: "st5",
    d: "M22.6,82.8c-1.8-0.7-3.6-1.6-5.4-2.4s-3.6-1.8-5.3-2.8c-3.5-1.9-6.8-4.2-9.7-7l0,0 c-0.5-0.5-1.3-0.5-1.7,0c-0.4,0.4-0.5,1.1-0.1,1.5c2.5,3.5,5.4,6.7,8.7,9.5c1.6,1.4,3.2,2.8,4.9,4.1c1.7,1.3,3.4,2.5,5.2,3.8 c1.7,1.2,4.1,0.7,5.2-1c1.2-1.7,0.7-4.1-1-5.2l0,0C23,83.1,22.8,82.9,22.6,82.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22365",
    className: "st5",
    d: "M28,77.1c-1.2-1.3-2.5-2.8-3.7-4.2s-2.4-2.9-3.6-4.4c-2.3-3-4.5-6-6.5-9.3l0,0 c-0.4-0.6-1.1-0.8-1.7-0.4c-0.5,0.3-0.7,0.9-0.5,1.5c1.3,3.7,2.8,7.3,4.5,10.9c0.8,1.8,1.7,3.5,2.6,5.2c0.9,1.7,1.8,3.4,2.8,5.2 c1,1.8,3.3,2.4,5.2,1.4c1.8-1,2.4-3.3,1.4-5.2c0,0,0,0,0,0C28.3,77.5,28.2,77.3,28,77.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22366",
    className: "st5",
    d: "M19,71.9c-1-0.8-2-1.8-3-2.7c-1-1-1.9-2-2.8-3.1c-1.8-2.2-3.4-4.5-4.7-7l0,0 c-0.3-0.6-1.1-0.9-1.7-0.6c-0.5,0.2-0.8,0.8-0.7,1.3c0.6,3.1,1.5,6,2.7,8.9c0.6,1.4,1.3,2.8,2,4.2c0.8,1.4,1.6,2.8,2.5,4.1l0.1,0.1 c1.2,1.7,3.6,2.2,5.3,0.9c1.7-1.2,2.2-3.6,0.9-5.3C19.6,72.4,19.3,72.1,19,71.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22367",
    className: "st5",
    d: "M19.4,79.6c-1.3-1.1-2.7-2.2-4-3.4s-2.6-2.3-3.9-3.5S9.1,70.2,8,69c-1.2-1.2-2.2-2.6-3.2-4 l0,0c-0.4-0.6-1.1-0.7-1.7-0.4c-0.5,0.3-0.7,0.9-0.5,1.4c0.6,1.8,1.4,3.5,2.4,5.1c0.9,1.6,1.8,3.2,2.8,4.7s2,3.1,3.1,4.5 s2.1,3,3.2,4.4l0,0c1.3,1.7,3.6,2,5.3,0.7c1.7-1.3,2-3.6,0.7-5.3C19.9,80,19.7,79.8,19.4,79.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22368",
    className: "st6",
    d: "M95.9,82.9l23,21.2l19-21c5.8-6.4,5.4-16.3-1-22.1c-6.3-5.8-16.2-5.4-22,0.9L95.9,82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22369",
    className: "st7",
    d: "M120,96.3c-0.1,0-0.2,0-0.3-0.1L99.9,78.5c-0.2-0.2-0.1-0.4,0-0.6c0.1-0.1,0.4-0.1,0.5,0 l19.8,17.7c0.2,0.1,0.2,0.4,0,0.6C120.2,96.2,120.1,96.3,120,96.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22370",
    className: "st6",
    d: "M108.7,144.4h87.1L213,93.1c3.9-12.8-3.3-26.4-16.1-30.3c-1-0.3-2-0.5-3-0.7l-55.1-9.5 c-13.2-2.3-25.7,6.6-28,19.8c-0.1,0.6-0.2,1.1-0.2,1.7L108.7,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22371",
    className: "st2",
    d: "M107.8,155.1h88.1l8.3-35.6l-94.6-4.7L107.8,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22372",
    className: "st8",
    d: "M109.6,114.8l94.6,4.7l1.2-3.7l-95.8-4.6L109.6,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22373",
    className: "st5",
    d: "M160.5,76L160.5,76c6.8,1.2,13.3-3.3,14.5-10.1c0,0,0,0,0,0l4.5-25.1 c1.2-6.8-3.3-13.3-10.1-14.5s-13.3,3.3-14.5,10.1l-4.5,25.1C149.2,68.2,153.7,74.7,160.5,76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22374",
    className: "st9",
    d: "M179.2,44.5l2.6-11.6c1.5-6.7-2.7-13.3-9.3-14.8c0,0,0,0,0,0c-6.7-1.5-14.8,4.8-16.3,11.5 l-5.9,32.8l29.1-17.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22375",
    className: "st5",
    d: "M149.1,52.7c-3.2-1-7.1-8.2-5.3-19.2c1-6,2.6-11.9,4.9-17.5c4.6-9.8,16.9-13.4,26.7-8.8 c9.8,4.6,13.9,16.3,9.3,26l-5.4,11.5C175.5,52.3,157.8,55.3,149.1,52.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22376",
    className: "st10",
    d: "M151.6,37.2c-0.4,0-0.8-0.1-1.1-0.4c-0.5-0.4-0.7-1.1-0.5-1.8c0.2-1,1.1-1.3,1.9-1.5 c0.3-0.1,0.7-0.2,1-0.4l1-2.2c0.1-0.1,0.2-0.2,0.4-0.1c0.1,0.1,0.2,0.2,0.1,0.4l-1,2.3c0,0-0.1,0.1-0.1,0.1 c-0.4,0.2-0.8,0.4-1.2,0.5c-0.7,0.2-1.3,0.4-1.5,1.1c-0.1,0.4,0,0.9,0.3,1.2c0.3,0.3,0.7,0.3,1.1,0.2c0.1-0.1,0.3,0,0.4,0.1 c0.1,0.1,0,0.3-0.1,0.4c0,0,0,0,0,0C152,37.2,151.8,37.2,151.6,37.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22377",
    className: "st10",
    d: "M151.3,46.7c-0.7,0-1.3-0.2-1.9-0.5c-0.1-0.1-0.1-0.2-0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1 l0,0c1.1,0.6,2.5,0.6,3.5-0.1c0.1-0.1,0.3,0,0.4,0.1c0.1,0.1,0,0.3-0.1,0.4l0,0C152.8,46.5,152,46.7,151.3,46.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22378",
    className: "st11",
    d: "M157.7,42.2c0.1-0.1,0.1-0.3,0-0.5c-0.1-0.1-0.2-0.1-0.2-0.1c-2,0-4-0.2-5.9-0.7 c-1.7-0.5-3.4-1.2-4.9-2.1c-0.1-0.1-0.3,0-0.3,0.1c0,0.1,0,0.1,0,0.2c0.3,1.3,1.3,4.6,4.4,5.4C153.7,45.3,156.5,43.3,157.7,42.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22379",
    className: "st12",
    d: "M187.4,15.5c3,13.9-4.7,22.2-4.7,22.2c-2.8-0.3-8.6-6.5-8.9-18.8L187.4,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22380",
    className: "st5",
    d: "M176.2,39.3c-0.5,2.5,1,4.9,3.5,5.5c2.5,0.5,4.9-1,5.5-3.5c0.5-2.5-1-4.9-3.5-5.5 C179.2,35.3,176.8,36.8,176.2,39.3C176.2,39.3,176.2,39.3,176.2,39.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22381",
    className: "st10",
    d: "M179.2,40.8C179.1,40.8,179.1,40.8,179.2,40.8c-0.2,0-0.3-0.2-0.3-0.3 c0.3-1.4,1.6-2.3,2.9-2c0.7,0.1,1.3,0.5,1.7,1.1c0.1,0.1,0.1,0.3-0.1,0.4s-0.3,0.1-0.4-0.1c-0.6-0.9-1.8-1.1-2.7-0.5 c-0.4,0.3-0.7,0.8-0.8,1.3C179.4,40.7,179.3,40.8,179.2,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22382",
    className: "st10",
    d: "M181.1,41.5c-0.1,0-0.2-0.1-0.3-0.2c-0.3-0.6-1-0.8-1.6-0.5c-0.1,0.1-0.3,0-0.4-0.1 c-0.1-0.1,0-0.3,0.1-0.4c0.9-0.4,1.9-0.1,2.4,0.8c0,0,0,0,0,0c0.1,0.1,0,0.3-0.1,0.4C181.2,41.5,181.2,41.5,181.1,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22383",
    className: "st12",
    d: "M177,39.2L177,39.2c0.9,0.4,2,0,2.4-1l2-4.7c0.4-0.9,0-2-1-2.4c-0.9-0.4-2,0-2.4,1l0,0 l-2,4.7C175.6,37.8,176.1,38.8,177,39.2C177,39.2,177,39.2,177,39.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22384",
    className: "st13",
    d: "M165.6,30.5c-0.2,0-0.4-0.1-0.5-0.3c-0.7-1-1.8-1.7-3-1.8c-0.3-0.1-0.5-0.4-0.5-0.7 s0.4-0.5,0.7-0.5c1.5,0.2,2.9,1,3.8,2.3c0.2,0.3,0.1,0.6-0.2,0.8c0,0,0,0,0,0C165.8,30.5,165.7,30.5,165.6,30.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22385",
    className: "st13",
    d: "M151.6,25.3c-0.1,0-0.2,0-0.3-0.1c-1-0.6-2.3-0.8-3.5-0.4c-0.3,0.1-0.6-0.1-0.7-0.4 c-0.1-0.3,0.1-0.6,0.4-0.7c1.5-0.4,3.1-0.2,4.4,0.6c0.3,0.2,0.3,0.5,0.2,0.8C152,25.2,151.8,25.3,151.6,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22386",
    className: "st11",
    d: "M162,31.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 c0,0,0,0,0,0C161,31.7,161.4,31.2,162,31.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22387",
    className: "st11",
    d: "M149.1,26.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 c0,0,0,0,0,0C148,27.2,148.5,26.7,149.1,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22388",
    className: "st14",
    d: "M181.8,94.8c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2v0 C179.8,95.7,180.7,94.8,181.8,94.8C181.8,94.8,181.8,94.8,181.8,94.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22389",
    className: "st5",
    d: "M152.1,153.5L152.1,153.5c5.3,3.7,12.6,2.3,16.3-3c0,0,0,0,0,0l41-59.8 c4.2-6.1,2.7-14.5-3.5-18.7c-6.1-4.2-14.5-2.7-18.7,3.5c-0.1,0.2-0.3,0.4-0.4,0.6l-37.7,61.3C145.4,142.6,146.8,149.9,152.1,153.5 C152.1,153.5,152.1,153.5,152.1,153.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22390",
    className: "st6",
    d: "M171.5,96.7l27.1,15.7l12.6-21.8c4.3-7.5,1.8-17.1-5.7-21.4s-17.1-1.8-21.4,5.7l0,0 L171.5,96.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22391",
    className: "st7",
    d: "M171.2,97.2c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.3-0.2-0.5c0,0,0,0,0,0l8.6-15.3 c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6L171.5,97C171.5,97.1,171.3,97.2,171.2,97.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22392",
    className: "st7",
    d: "M197.9,104.5c-0.1,0-0.1,0-0.2-0.1l-23.2-12.9c-0.2-0.1-0.3-0.4-0.2-0.6s0.4-0.3,0.6-0.2 l0,0l23.2,12.9c0.2,0.1,0.3,0.3,0.2,0.5C198.2,104.4,198,104.5,197.9,104.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22393",
    className: "st7",
    d: "M162.6,79.7c-1.1,0-2.2-0.1-3.2-0.3c-8.6-1.8-14.1-10.2-12.4-18.7c0,0,0,0,0,0 c0-0.2,0.3-0.4,0.5-0.3c0.2,0,0.4,0.3,0.3,0.5c-1.7,8.2,3.6,16.1,11.7,17.8c8.2,1.7,16.1-3.6,17.8-11.7c0-0.2,0.3-0.4,0.5-0.3 s0.4,0.3,0.3,0.5l0,0C176.6,74.3,170.2,79.6,162.6,79.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22394",
    className: "st7",
    d: "M108.5,101.5L108.5,101.5c-0.3,0-0.4-0.2-0.4-0.4l2-22.9c0-0.2,0.2-0.4,0.4-0.4 c0.2,0,0.4,0.2,0.4,0.4l-2,22.9C108.9,101.3,108.8,101.5,108.5,101.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22395",
    className: "st13",
    d: "M173.8,18.9c-6.8,0.9-22.6-3.8-25.5-11.3c3,0.5,7.6-7,16.6-7.5 c8.7-0.5,21.7,6.3,22.4,15.5C185,18.3,181,20.9,173.8,18.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22396",
    className: "st13",
    d: "M151.7,38c0,0-1.2-0.4-3.1-1.1c-5-1.7-5.6,2.7-5.6,2.7s-1.9,10,2.4,11.8 c2.8,1.2,5.7,2,8.7,2.4c3.9,0.7,12.2,1.4,16.1-1.2c4.2-2.8,7.9-9.4,9.6-15.5l-2.5-0.9c-0.5-0.1-1,0.1-1.2,0.5 c-1.1,2.2-4.7,8.7-14.2,7c0.2-1.4-0.7-4-4.4-4.8c-1.8-0.4-5-0.9-5-0.9l-0.2,0.9c0,0,5.3,0.5,6.6,2.2c0.7,0.9,0.4,1.4,0.3,2.1 s-1.3,6.7-9.9,4.7c-5.2-1.2-5.1-8.9-3.7-10.1c1.1-1,5.9,1,5.9,1L151.7,38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22397",
    className: "st5",
    d: "M111.4,78L111.4,78c-3.4,2.3-4,7.4-1.5,11.6l37.7,59.4c4.4,6.3,12.2,8.5,17.5,4.8 s6.1-11.8,1.7-18.1l-44.2-55.1C119.6,76.8,114.7,75.7,111.4,78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22398",
    className: "st5",
    d: "M114.6,85c0.2-1.8,0.5-3.5,0.9-5.2c0.4-1.7,0.9-3.3,1.6-4.9c0.6-1.6,1.5-3.1,2.4-4.6 c1.1-1.6,2.4-2.9,3.9-4c1,0.1,1.3,1,0.9,1.5l0,0c-1.6,2.4-2.6,5.2-2.7,8.1c-0.1,1.5-0.1,2.9,0,4.4c0.1,1.5,0.3,3.1,0.6,4.6 c0.3,1,0,2.1-0.7,2.8c-1.3,1.7-3.7,2-5.4,0.7c-1-0.8-1.6-2.1-1.5-3.4L114.6,85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22399",
    className: "st5",
    d: "M112.7,79.5c-0.1-1.9-0.3-3.9-0.6-5.9c-0.3-2-0.6-4-1-5.9c-0.7-3.9-1.9-7.7-3.5-11.4 l-0.2-0.5c0-0.1,0-0.1,0-0.2c0.1-0.7,0.8-1.2,1.5-1.1c0.3,0,0.6,0.2,0.8,0.5c2.5,3.5,4.6,7.2,6.2,11.2c0.8,2,1.6,4,2.3,6 c0.8,2.2,1.5,4.3,2.1,6.7c0.3,0.9,0,1.9-0.6,2.7c-1.2,1.7-3.6,2.2-5.4,0.9c-0.7-0.5-1.2-1.2-1.5-2.1 C112.8,80,112.8,79.8,112.7,79.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22400",
    className: "st5",
    d: "M109.8,89.3c-0.9-1.6-1.9-3.2-2.8-4.8s-2-3.2-3-4.8c-2.1-3.2-4.3-6.2-6.7-9.1l-0.3-0.4 c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.7,0.5-1.4,1.2-1.4c0.3,0,0.6,0.1,0.9,0.2c3.1,2.4,6.1,5,8.9,7.7c1.4,1.4,2.8,2.7,4.1,4.1 c1.4,1.4,2.7,2.8,4,4.3c1.4,1.6,1.3,4-0.3,5.3s-4,1.3-5.3-0.3C110.1,89.8,109.9,89.5,109.8,89.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22401",
    className: "st5",
    d: "M107.1,77.5c-0.6-1.2-1.2-2.4-1.9-3.6c-0.7-1.2-1.5-2.4-2.3-3.5c-1.6-2.3-3.5-4.4-5.6-6.3 L97,63.8c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-1.4,1-1.9,1.8-1.5c2.8,1.3,5.5,3,7.9,4.9c1.2,1,2.4,2,3.6,3c1.2,1.1,2.3,2.3,3.4,3.5 l0.4,0.5c0.6,0.7,0.8,1.7,0.6,2.6c-0.9,3.7-4.9,4.2-6.8,1.9C107.5,78.2,107.3,77.9,107.1,77.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22402",
    className: "st5",
    d: "M111.8,77.2c-0.7-1.5-1.5-3.1-2.3-4.7s-1.7-3.1-2.5-4.6s-1.8-3-2.7-4.4 c-0.9-1.4-2-2.8-3.1-4l-0.4-0.4c-0.1-0.1-0.1-0.1-0.1-0.2c0-1.4,1.2-1.8,2-1.3c1.6,1,3,2.2,4.4,3.5c1.4,1.2,2.7,2.5,3.9,3.9 s2.5,2.7,3.7,4s2.4,2.7,3.6,4.2l0.4,0.5c0.6,0.7,0.8,1.7,0.5,2.5c-1,3.6-5,4-6.8,1.8C112.1,77.8,111.9,77.5,111.8,77.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22424",
    className: "st7",
    d: "M151.6,40.9c-1.4-0.4-2.7-0.9-3.9-1.5c0.3,1.1,1.7,2.2,3.5,2.8c1.9,0.6,3.8,0.3,4.5-0.6 C154.3,41.5,152.9,41.3,151.6,40.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22339",
    className: "st3",
    d: "M99.7,377.8h55.7v-18.1c0-1.5-1.2-2.8-2.8-2.8c-0.1,0-0.1,0-0.2,0l-35.7,4.6 C107.2,362,99.7,367.9,99.7,377.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22341",
    className: "st4",
    d: "M100,380.2h55.6c0.7,0,1.3-0.6,1.3-1.3v-2.2c0-0.7-0.6-1.3-1.3-1.3H100 c-0.7,0-1.3,0.6-1.3,1.3v2.2C98.7,379.6,99.3,380.2,100,380.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22342",
    className: "st0",
    d: "M144.8,374.5c-0.1,0-0.3-0.1-0.3-0.3v0c0-5.2,4.2-9.4,9.4-9.4c0.1,0,0.3,0.1,0.3,0.3 s-0.1,0.3-0.3,0.3c-4.9,0-8.9,4-8.9,8.9C145.1,374.4,145,374.5,144.8,374.5L144.8,374.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22343",
    className: "st0",
    d: "M123.6,367.6L123.6,367.6c-0.2,0-0.3-0.2-0.3-0.3c0,0,0,0,0,0c0.2-2.3-0.1-4.7-1-6.9 c-0.1-0.1,0-0.3,0.2-0.3c0.1-0.1,0.3,0,0.3,0.2c0.9,2.3,1.3,4.7,1,7.2C123.8,367.5,123.7,367.6,123.6,367.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22344",
    className: "st0",
    d: "M117.4,367.6L117.4,367.6c-0.2,0-0.3-0.2-0.3-0.3c0,0,0,0,0,0c0.2-2.1-0.1-4.2-0.8-6.2 c0-0.1,0-0.3,0.2-0.3s0.3,0,0.3,0.2c0.7,2.1,1,4.3,0.8,6.5C117.6,367.5,117.5,367.6,117.4,367.6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration2);
export default __webpack_public_path__ + "static/media/illustration_2.fed543e0845704b4aa877a54d6db2ba6.svg";
export { ForwardRef as ReactComponent };